import React, { Dispatch, SetStateAction } from "react";
import { Button } from "primereact/button";
import { useForm, Controller } from "react-hook-form";
import { forgotPasswordService } from "../../Services/authenticationService";
import { useTranslation } from "react-i18next";
import { DashlyTextInput } from "../../Components/inputs/DashlyTextInput/DashlyTextInput";

interface ForgotPasswordFormProps {
    setSuccessMessage: Dispatch<SetStateAction<string | null>>;
    setErrorMessage: Dispatch<SetStateAction<string | null>>;
    onBackToLogin: () => void;
}

const ForgotPasswordForm = ({ setSuccessMessage, setErrorMessage, onBackToLogin }: ForgotPasswordFormProps) => {
    const { handleSubmit, control } = useForm<{ email: string }>();
    const { t } = useTranslation();

    const onSubmit = handleSubmit((data) => {
        forgotPasswordService(data.email).finally(() => {
            setSuccessMessage(t("login.message.password.forgot"));
            onBackToLogin();
        });
    });

    return (
        <form className="sign-in__form" onSubmit={onSubmit}>
            <div className="sign-in__intro">
                <h1 className="sign-in__title">{t("login.reset-password")}</h1>
            </div>

            <div className="sign-in__fields">
                <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                        <DashlyTextInput
                            {...field}
                            placeholder={t("login.username.mail")}
                            autoComplete="email"
                            autoFocus
                            required
                        />
                    )}
                />
            </div>

            <div className="sign-in__actions">
                <Button
                    text
                    className="sign-in__action-btn sign-in__action-btn--cancel"
                    type="button"
                    label={t("common.action.back")}
                    onClick={onBackToLogin}
                />
                <Button
                    className="sign-in__action-btn sign-in__action-btn--primary"
                    type="submit"
                    label={t("login.reset-password")}
                />
            </div>
        </form>
    );
};

export default ForgotPasswordForm;
